import React from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { Label, Message } from '@naf/input';
import S from '../Styles';
import { normalizeInput } from '../../../../../utils/normalizeInput';

interface Props {
  errorMessage?: string;
  isDisabled?: boolean;
}

export const FirstName = <T extends FieldValues>({
  name,
  control,
  defaultValue,
  errorMessage,
  isDisabled,
}: UseControllerProps<T> & Props) => (
  <S.FirstName>
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { value, onChange } }) => (
        <S.FieldWrapper>
          <Label>Fornavn og mellomnavn</Label>
          <S.ResponsiveTextField
            error={!!errorMessage}
            onChange={(e) => onChange(normalizeInput(e))}
            value={value}
            autoComplete="given-name"
            disabled={isDisabled}
          />
          {!!errorMessage && <Message error>{errorMessage}</Message>}
        </S.FieldWrapper>
      )}
    />
  </S.FirstName>
);
